import React from 'react';
import ReadOnlyTemplate from '../components/ReadOnlyTemplate';
import { whatIsWeb3Data } from '../data/whatIsWeb3Data';

const WhatIsWeb3 = () => {
  return (
    <ReadOnlyTemplate
      title="What is Web3?"
      sections={whatIsWeb3Data}
    />
  );
};

export default WhatIsWeb3;